import { render } from "./TalkNowOfTopScreen.vue?vue&type=template&id=352329ba&scoped=true&ts=true&lang=pug"
import script from "./TalkNowOfTopScreen.vue?vue&type=script&lang=ts"
export * from "./TalkNowOfTopScreen.vue?vue&type=script&lang=ts"

import "./TalkNowOfTopScreen.vue?vue&type=style&index=0&id=352329ba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352329ba"]])

export default __exports__